function escapeHtmlAttribute(value: string) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

export function createPlacementUnitTag(secondaryId: string | null | undefined, cdnUrl: string) {
  if (!secondaryId) return '';
  const normalizedCdnUrl = cdnUrl.replace(/\/+$/, '');
  const escapedSecondaryId = escapeHtmlAttribute(secondaryId);
  const escapedCdnUrl = escapeHtmlAttribute(normalizedCdnUrl);
  const encodedSecondaryId = escapeHtmlAttribute(encodeURIComponent(secondaryId));
  return `<script type="text/javascript" id="${escapedSecondaryId}" src="${escapedCdnUrl}/${encodedSecondaryId}/index.js" charset="utf-8" async></script>`;
}
